var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocked = function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.3966 10.3991H16.8341V8.79931C16.7997 6.14598 14.6231 4 11.9506 4C9.2781 4 7.09923 6.14598 7.06479 8.79931V10.3991H6.6033C5.90532 10.3991 5.34052 10.9613 5.34052 11.656V18.743C5.34052 19.4378 5.90532 20 6.6033 20H17.3966C18.0946 20 18.6594 19.4378 18.6594 18.743V11.656C18.6594 10.9613 18.0946 10.3991 17.3966 10.3991ZM8.44237 10.3991V8.86331C8.44237 6.93901 10.0151 5.37123 11.9506 5.37123C13.8861 5.37123 15.4588 6.93672 15.4588 8.86331V10.3991H8.44466H8.44237Z"
  })));
};
export default SvgLocked;